export default function () {
    new Swiper(".our_impact__swiper", {
        slidesPerView: 1,
        spaceBetween: 24,
        loop: true,
        navigation: {
            nextEl: ".our_impact__swiper__btn.next",
            prevEl: ".our_impact__swiper__btn.prev",
        },
        breakpoints: {
            768: {
                slidesPerView: 'auto',
            },
        }
    });
}